import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PartnershipPage from "@/pages/PartnershipPage";

export const Route = createFileRoute("/partnership")({
  head: () => pageHead("Partnerships", "Strategic partnerships with leading AI providers, government agencies, and veteran organizations to deliver exceptional value.", "/partnership", false),
  component: PartnershipPage,
});
